import type { IDimensionSpecifications, IValueAndUnit } from '@/interfaces'
import Base from '@/models/Base'
import ValueAndUnit from './ValueAndUnit'

class DimensionSpecifications extends Base implements IDimensionSpecifications {
  width: IValueAndUnit<number>
  height: IValueAndUnit<number>
  length: IValueAndUnit<number>
  weight: IValueAndUnit<number>
  volume: IValueAndUnit<number>
  passengerVolume: IValueAndUnit<number>
  cargoVolume: IValueAndUnit<number>
  internalVolume: IValueAndUnit<number>
  groundClearance: IValueAndUnit<number>

  constructor(dimensionSpecifications?: any) {
    super(dimensionSpecifications)
    this.width = new ValueAndUnit(dimensionSpecifications?.width)
    this.height = new ValueAndUnit(dimensionSpecifications?.height)
    this.length = new ValueAndUnit(dimensionSpecifications?.length)
    this.weight = new ValueAndUnit(dimensionSpecifications?.weight)
    this.volume = new ValueAndUnit(dimensionSpecifications?.volume)
    this.passengerVolume = new ValueAndUnit(dimensionSpecifications?.passengerVolume)
    this.cargoVolume = new ValueAndUnit(dimensionSpecifications?.cargoVolume)
    this.internalVolume = new ValueAndUnit(dimensionSpecifications?.internalVolume)
    this.groundClearance = new ValueAndUnit(dimensionSpecifications?.groundClearance)
  }
}

export default DimensionSpecifications
